<!-- 头部日期时间 -->
<template>
    <div class="header-time">
        <div class="header-time-content">
            <img loading="lazy" v-lazy="require('../assets/images/amjs/china.jpg')" alt="china">
            <span class="header-time-text">{{zone}}</span>
            <span>北京时间：</span>
            <span class="header-time-text">{{date}}</span>
            <span >{{time}}</span>
        </div>
    </div>
</template>

<script>
import utils from '@/utils/utils.js'
export default {
    data () {
        return {
            zone: 'UTC+8',
            date: '',
            time: '',
            interval: 0
        }
    },
    methods: {
        getTime () {
            this.interval = setInterval(() => {
                var bjTime = this.getBjTime();
                this.date = utils._formatDate(bjTime, 'yyyy-MM-dd')
                this.time = utils._formatDate(bjTime, 'HH:mm:ss')
            }, 500)
        },
        getBjTime() {
            //获得当前运行环境时间
            var d = new Date(), currentDate = new Date(), tmpHours = currentDate.getHours();
            //算得时区
            var time_zone = -d.getTimezoneOffset() / 60;
            //少于0的是西区 西区应该用时区绝对值加京八区 重新设置时间（西区时间比东区时间早 所以加时区间隔）
            if (time_zone < 0) {
                time_zone = Math.abs(time_zone) + 8; currentDate.setHours(tmpHours + time_zone);
            } else {
                //大于0的是东区  东区时间直接跟京八区相减
                time_zone -= 8; currentDate.setHours(tmpHours - time_zone);
            }
            return currentDate;
        },
    },
    mounted () {
        this.getTime()
    },
    beforeDestroy () {
        if (this.interval) clearInterval(this.interval)
    }
}

</script>

<style scoped>
.header-time {
    background: #000;
    color: rgba(255, 255, 255, 0.6);
    font-size: 14px;
    padding: 5px 0;
}
.header-time-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.header-time-text {
    margin-right: 10px
}
.header-time-content img {
    height: 15px;
    border-radius: 2px;
    margin-right: 10px;
}
</style>